import { router } from '@inertiajs/vue3';

export function useFornecedorNavigation() {
    const getAreaFornecedorRoute = () => route('fornecedor');
    const getMeusEmpenhosRoute = () => route('fornecedor.meus-empenhos');
    const getMinhasNotasRoute = () => route('fornecedor.minhas-notas');

    const goToAreaFornecedor = () => router.visit(getAreaFornecedorRoute());
    const goToMeusEmpenhos = () => router.visit(getMeusEmpenhosRoute());
    const goToMinhasNotas = () => router.visit(getMinhasNotasRoute());

    return { getAreaFornecedorRoute, getMeusEmpenhosRoute, getMinhasNotasRoute, goToAreaFornecedor, goToMeusEmpenhos, goToMinhasNotas };
}
